import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchCampaignRecipients } from '@/lib/venue/campaignApi'
import type { RecipientReadFilter } from '@/lib/venue/campaignViewModel'

export function campaignRecipientsQueryKey(venueId: string, campaignId: number, read: RecipientReadFilter) {
  return ['venue', venueId, 'campaign-recipients', campaignId, read] as const
}

/** 대상별 읽음 목록(#728 §6) — `enabled`로 상세 페이지의 "대상별 읽음" 탭이 열렸을 때만 조회한다. */
export function useCampaignRecipients(
  venueId: string,
  campaignId: number,
  read: RecipientReadFilter,
  enabled: boolean
) {
  return useInfiniteQuery({
    queryKey: campaignRecipientsQueryKey(venueId, campaignId, read),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchCampaignRecipients(venueId, campaignId, { read }, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
    enabled,
  })
}
